import axios from 'axios';
import { handleQueryIncludeArray } from '@/util/ds-util';

const BASE_URL = 'api/recap';
const URL_RECAP_SETTING = 'api/recap-settings';
const URL_PODCAST = 'api/podcasts';
export default class RecapService {
  async getRecapDetails(id: string) {
    try {
      const response = await axios.get(BASE_URL + `/get-recap-by-id`, {
        params: { id },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  public getHtmlRecapPageById(recapId: string) {
    return axios.get(BASE_URL + '/' + recapId);
  }

  async getRecapListDayView(userKey: string, size: number) {
    try {
      const response = await axios.get(BASE_URL + `/get-list-view-recap`, {
        params: { userKey, size },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async getRecapByDay(userKey: string, dateGetRecap: string) {
    try {
      const response = await axios.get(BASE_URL + `/get-recap-by-day`, {
        params: { userKey, dateGetRecap },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async updateViewedRecap(userKey: string, dateViewedRecap: string) {
    try {
      const response = await axios.get(BASE_URL + `/update-is-viewed-recap`, {
        params: { userKey, dateViewedRecap },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async getListPodcast(lang: string) {
    try {
      const response = await axios.get(BASE_URL + `/get-all-speaker`, {
        params: { lang },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async saveOrUpdate(requestBody: any) {
    try {
      const response = await axios.post(URL_RECAP_SETTING, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error('API error:', error);
    }
  }

  async getRecapSettingByUserId(userId: string) {
    try {
      const response = await axios.get(URL_RECAP_SETTING + `/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async generatePodcast(requestBody: any) {
    try {
      const response = await axios.post(URL_PODCAST + '/generate-podcast', requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error('API error:', error);
    }
  }

  async savePodcastSetting(requestBody: any) {
    try {
      const response = await axios.post(URL_PODCAST + '/save', requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error('API error:', error);
    }
  }

  async getPodcast(userId: string, recapId: string, speakerId: string) {
    try {
      const response = await axios.get(URL_PODCAST + `/get-podcast`, {
        params: { userId, recapId, speakerId },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async fetchAndSavePodcastData(userKey: string, recapId: string) {
    try {
      const response = await axios.get(URL_PODCAST + `/fetch`, {
        params: { userKey, recapId },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  public callApiGetRecapByDate(userKeyInput: string, dateGetRecapInput: string[]) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/recap/get-recap-by-day-post', null, {
          params: {
            userKey: userKeyInput,
            dateGetRecap: dateGetRecapInput,
          },
          paramsSerializer: query => handleQueryIncludeArray(query),
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getListDayViewRecap(fromDate: string, size: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/recap/get-list-day-view-recap?fromDate=' + fromDate + '&size=' + size)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  async getNewPodcast(userId: string, recapId: string) {
    try {
      const response = await axios.get(URL_PODCAST + `/get-new-podcast`, {
        params: { userId, recapId },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async editRecapPodcast(requestBody: any) {
    try {
      const response = await axios.post(URL_PODCAST + '/edit-recap-podcast', requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error('API error:', error);
    }
  }

  async getAllPodcastByUser(userKey: string, mediaType: string, pageNumber: number, pageSize: number) {
    try {
      const response = await axios.get(URL_PODCAST + `/get-all-podcast-by-user`, {
        params: { userKey, mediaType, pageNumber, pageSize },
      });
      return response.data;
    } catch (error) {
      console.error('Error in RecapService:', error);
      throw error;
    }
  }

  async countPodcast(userKey: string, documentType: string, mediaType: string) {
    try {
      const response = await axios.get(URL_PODCAST + '/count-podcast', {
        params: { userKey, documentType, mediaType },
      });
      return response.data;
    } catch (error) {
      console.error('API error: ', error);
    }
  }
}
